import { HttpService } from '@services/HttpService'
import { BEARER, APPLICATION_JSON, ACCESS_TOKEN } from '@constants'
import { config } from '@config'
import { storage } from '@services/storageService'

export default class ConfigurationService {
  private httpService = new HttpService()

  getConfiguration = async () => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/configuration`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)

      const result = await this.httpService.get(url, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      return result.data
    } catch (e) {
      console.log('Failed to fetch configuration')
      throw new Error('settings.configuration.errors.fetchConfiguration')
    }
  }

  updateConfiguration = async (configuration: any) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/configuration`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)

      const result = await this.httpService.put(url, configuration, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      return result.data
    } catch (e) {
      console.log('Failed to update configuration')
      throw new Error('settings.configuration.errors.updateConfiguration')
    }
  }
}
